import { combineReducers } from 'redux'
import { mobileReducer } from './modules/mobile'
import authReducer, { moduleName as authModule } from './modules/auth'
import docsReducer, { moduleName as docsModule } from './modules/docs'
import newsReducer, { moduleName as newsModule } from './modules/news'
import contactsReducer, { moduleName as contactsModule } from './modules/contacts'
import CheckClientReducer, { moduleName as CheckClientModule } from './modules/check-client'
import AgentsReducer, { moduleName as AgentsModule } from './modules/agents'
import MeetingReducer, { moduleName as MeetingModule } from './modules/meeting'
import RealtyReducer, { moduleName as RealtyModule } from './modules/realty'
import ClientsReducer, { moduleName as ClientsModule } from './modules/clients'
import BookingReducer, { moduleName as BookingModule } from './modules/bookings'
import OrdersReducer, { moduleName as OrdersModule } from './modules/orders'
import DealsReducer, { moduleName as DealsModule } from './modules/deals'

const appReducer = combineReducers({
	mobile: mobileReducer,
	[authModule]: authReducer,
	[docsModule]: docsReducer,
	[newsModule]: newsReducer,
	[contactsModule]: contactsReducer,
	[CheckClientModule]: CheckClientReducer,
	[AgentsModule]: AgentsReducer,
	[MeetingModule]: MeetingReducer,
	[RealtyModule]: RealtyReducer,
	[ClientsModule]: ClientsReducer,
	[BookingModule]: BookingReducer,
	[OrdersModule]: OrdersReducer,
	[DealsModule]: DealsReducer,
})


const rootReducer = (state, action) => {
	if (action.type === 'auth/SIGN_OUT') {
	  state = undefined
	}
   
	return appReducer(state, action)
}

export default rootReducer;